const jsPDF = require('jspdf')
require('jspdf-autotable')
const { getStyle } = require('./reportStyle')
const {
  headerFromUser, addTable,
  pdfPageByDay
} = require('./util/pdfDocument')
const { getUserPartner } = require('fleetmap-partners')
const traccar = require('./util/traccar')
const { getDates, getTranslations, isClientSide, executeServerSide } = require('./util/utils')
const driversUtil = require('./util/driver')
const {
  isInsideTimetable, isPartialInsideTimetable, calculateTrip, getDataByDay, getKms,
  getTripTotalKms, calculateMultiDayTrips
} = require('./util/trips')
const { devicesToProcess } = require('./util/device')
const { getDriverData, reportByDriver } = require('./util/driver')
const automaticReports = require('./automaticReports')
const { getSummaryByDay } = require('./util/traccar')
const { getStop } = require('./trip-report')

const fileName = 'KmsReport'

async function createKmsReport (from, to, userData, traccarInstance) {
  console.log('Create KmsReport', from, to, userData.byDriver ? 'by driver' : (userData.byGroup ? 'by group' : 'by device'))
  const reportData = []
  if (userData.byDriver) {
    const allData = await createKmsReportByDriver(from, to, userData, traccarInstance)
    reportData.push(allData)
  } else if (userData.byGroup) {
    const allData = await createKmsReportByGroup(from, to, userData, traccarInstance)
    reportData.push(...allData)
  } else {
    const allData = await createKmsReportByDevice(from, to, userData, traccarInstance)
    reportData.push(allData)
  }

  return reportData
}

async function createKmsReportByDevice (from, to, userData, traccarInstance) {
  const allDevices = devicesToProcess(userData)

  const allData = {
    devices: [],
    from,
    to
  }

  if (isClientSide() && (allDevices.length > 50 || ((new Date(to).getTime() - new Date(from).getTime()) > (1000 * 60 * 60 * 24 * 15))) && userData.groupByDay) {
    const sliced = automaticReports.sliceArray(allDevices, 1)
    await executeServerSide('kms-report', sliced, from, to, userData, allDevices.length, traccarInstance).then(devices => {
      allData.devices = devices
    })
  } else {
    if (userData.allWeek && userData.groupByDay) {
      const dates = getDates(from, to, userData.user.attributes.timezone || getUserPartner(userData.user).timezone)
      const summary = await getSummaryByDay(dates, userData, traccarInstance, allDevices, false, from, to)
      for (const device of allDevices) {
        const days = []
        dates.forEach(date => {
          const summaryByDay = summary.find(a => a.date === date).summary
          const summaryByDevice = summaryByDay.find(a => a.deviceId === device.id)
          if (summaryByDevice) {
            days.push({
              date,
              kms: summaryByDevice.distance,
              startOdometer: summaryByDevice.startOdometer,
              endOdometer: summaryByDevice.endOdometer
            })
          }
        })
        const daysWithOdometer = days.filter(a => a.startOdometer > 0)
        allData.devices.push({
          device,
          startOdometer: daysWithOdometer.length > 0 ? daysWithOdometer[0].startOdometer : 0,
          endOdometer: daysWithOdometer.length > 0 ? daysWithOdometer[daysWithOdometer.length - 1].endOdometer : 0,
          days
        })
      }
    } else {
      let deviceCount = 0
      const sliced = automaticReports.sliceArray(allDevices,
        20)
      for (const devices of sliced) {
        const needRoute = userData.groupByDay || !userData.allWeek
        const {
          trips,
          route,
          summary
        } = await traccar.getAllInOne(traccarInstance, from, to, devices, needRoute, true, false, !userData.groupByDay, deviceCount, allDevices.length, 10, 2)

        // Process report data
        if (trips.length) {
          allData.devices = allData.devices.concat(await processDevices(from, to, devices, {
            trips,
            route,
            summary
          }, userData, traccarInstance))
        }
        deviceCount += devices.length
      }
    }
  }

  return allData
}

async function createKmsReportByDriver (from, to, userData, traccarInstance) {
  const report = { drivers: [] }

  if (!userData.requestToRunServerSide) {
    const { devices, drivers } = await driversUtil.devicesByDriver(traccarInstance, from, to, userData.drivers, userData.devices)
    userData.devices = devices
    userData.drivers = drivers
  }

  if (isClientSide() && (userData.drivers.length > 50 || ((new Date(to).getTime() - new Date(from).getTime()) > (1000 * 60 * 60 * 24 * 15))) && userData.groupByDay) {
    const sliced = automaticReports.sliceArray(userData.drivers, 10)
    userData.requestToRunServerSide = true
    await executeServerSide('kms-report', sliced, from, to, userData, userData.drivers.length, traccarInstance, 5).then(drivers => {
      report.drivers = drivers
    })
  } else {
    const results = await reportByDriver(userData.devices, traccarInstance, from, to, userData, processDrivers, { route: !userData.allWeek || userData.byDriver, trips: true, stops: true, summary: false })

    results.drivers.forEach(result => {
      const driver = report.drivers.find(d => d.driver.id === result.driver.id)
      if (driver) {
        if (userData.groupByDay) {
          driver.days.forEach(day => {
            const resultDay = result.days.find(d => d.date === day.date)
            if (resultDay) {
              day.kms = day.kms + resultDay.kms
            }
          })
        } else {
          driver.summary.distance = driver.summary.distance + result.summary.distance
        }
      } else {
        report.drivers.push(result)
      }
    })
  }

  return report
}

async function createKmsReportByGroup (from, to, userData, traccarInstance) {
  const reportData = []
  for (const g of userData.groups) {
    const devices = userData.devices.filter(d => d.groupId === g.id)
    console.log(g.name + ' devices:' + devices.length)
    if (devices.length > 0) {
      const groupData = {
        devices: [],
        group: g,
        xpert: devices.filter(d => d.attributes.xpert).length > 0
      }

      const route = userData.allWeek ? [] : await traccar.getRoute(traccarInstance, from, to, devices)
      const tripsData = await traccar.getTrips(traccarInstance, from, to, devices)

      devices.sort((a, b) => (a.name > b.name) ? 1 : -1)

      console.log('trips:' + tripsData.length)

      if (tripsData.length > 0) {
        groupData.devices = await processDevices(from, to, devices, { trips: tripsData, route }, userData, traccarInstance)
      }

      reportData.push(groupData)
    }
  }

  const withoutGroupData = await createKmsReportByDevice(from, to, userData, traccarInstance)
  reportData.push(withoutGroupData)

  return reportData
}

async function processDrivers (from, to, userData, data) {
  const driversResult = []

  for (const d of userData.drivers) {
    const { trips, route } = await getDriverData(d, data, userData)

    if (trips.length > 0) {
      const driverData = {
        driver: d
      }
      if (userData.groupByDay) {
        driverData.days = []
        const dates = getDates(from, to)
        for (const date of dates) {
          const fromByDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
          const toByDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)

          const tripsByDay = trips.filter(t => (new Date(t.startTime) > fromByDay && new Date(t.endTime) < toByDay))

          calculateMultiDayTrips(trips, route, tripsByDay, fromByDay, toByDay, userData.devices)

          driverData.days.push({
            date,
            kms: tripsByDay.filter(t => t.distance > 0).reduce((a, b) => a + b.distance, 0)
          })
        }
      } else {
        driverData.summary = {
          distance: trips.reduce((a, b) =>
            a + getTripTotalKms(
              b,
              getStop(new Date(b.endTime), data.stops.filter(s => s.deviceId === b.deviceId)),
              data.route.filter(r => r.deviceId === b.deviceId)
            ), 0
          ) * 1000
        }
      }
      driversResult.push(driverData)
    }
  }

  return driversResult
}

async function processDevices (from, to, devices, data, userData, traccarInstance) {
  const devicesResult = []

  for (const d of devices) {
    const deviceRoute = data.route.filter(t => t.deviceId === d.id)
    const deviceTrips = data.trips.filter(t => t.deviceId === d.id)

    let uncompletedTripRoute = []
    if (deviceRoute.length && deviceTrips.length && deviceRoute[deviceRoute.length - 1].attributes.ignition) {
      uncompletedTripRoute = deviceRoute.filter(p => p.attributes.ignition && new Date(p.fixTime).getTime() > new Date(deviceTrips[deviceTrips.length - 1].endTime).getTime())
      if (uncompletedTripRoute.length) {
        deviceTrips.push(calculateTrip(d, uncompletedTripRoute))
      }
    }

    const trips = deviceTrips.filter(t => userData.allWeek || !userData.weekDays || isInsideTimetable(t, userData) || isPartialInsideTimetable(t, userData, deviceRoute))

    if (userData.groupByDay) {
      if (trips.length > 0) {
        const dates = getDates(from, to, userData.user.attributes.timezone || getUserPartner(userData.user).timezone)
        const days = await Promise.all(dates.map(async date => {
          const { tripsByDay } = await getDataByDay(d, date, { trips }, userData, traccarInstance)
          return {
            date,
            kms: getKms(tripsByDay)
          }
        }))

        devicesResult.push({
          device: d,
          startOdometer: trips.length ? trips[0].startOdometer : 0,
          endOdometer: trips.length ? trips[trips.length - 1].endOdometer : 0,
          days
        })
      }
    } else {
      const summary = data.summary.find(s => s.deviceId === d.id)
      devicesResult.push({
        device: d,
        summary
      })
    }
  }

  return devicesResult
}

async function exportKmsReportToPDF (userData, reportData) {
  const translations = getTranslations(userData)
  const kmsData = userData.byDriver ? reportData.drivers : reportData.devices

  const weekDays = [
    translations.report.sunday,
    translations.report.monday,
    translations.report.tuesday,
    translations.report.wednesday,
    translations.report.thursday,
    translations.report.friday,
    translations.report.saturday
  ]

  const headers = []
  if (userData.groupByDay) {
    headers.push(translations.report.date,
      translations.report.distance)
  } else if (userData.byDriver) {
    headers.push(translations.report.driver,
      translations.report.group,
      translations.report.distance)
  } else {
    headers.push(translations.report.vehicle,
      translations.settings.vehicle_model,
      translations.report.group,
      translations.report.distance)
  }
  if (kmsData) {
    const orientation = userData.groupByDay ? 'p' : 'l'
    // eslint-disable-next-line new-cap
    const doc = new jsPDF.jsPDF(orientation)
    await headerFromUser(doc, translations.report.titleKmsReport, userData.user, orientation)

    if (userData.groupByDay) {
      kmsData.forEach(function (d, index) {
        pdfPageByDay(userData, d, index, doc, translations, reportData)

        const data = []
        if (d.days) {
          d.days.forEach(day => {
            const temp = [
              new Date(day.date).toLocaleDateString() + ' - ' + weekDays[new Date(day.date).getDay()],
              (day.kms / 1000).toFixed(0)
            ]

            data.push(temp)
          })

          const footValues = []
          footValues.push(
            '',
            (d.days.reduce((a, b) => a + b.kms, 0) / 1000).toFixed(0)
          )

          const style = getStyle(getUserPartner(userData.user))
          addTable(doc, headers, data, footValues, style, 40)
        }
      })
    } else {
      doc.setFontSize(11)
      doc.text(new Date(reportData.from).toLocaleString() + ' - ' + new Date(reportData.to).toLocaleString(), 20, 33)

      const data = []
      if (userData.byDriver) {
        reportData.drivers.forEach(d => {
          const group = userData.groups.find(g => g.drivers && g.drivers.includes(d.driver.id))

          const temp = [
            d.driver.name,
            group ? group.name : '',
            Number((d.summary.distance / 1000).toFixed(0))
          ]
          data.push(temp)
        })
      } else {
        reportData.devices.forEach(d => {
          const group = userData.groups.find(g => d.device.groupId === g.id)

          const temp = [
            d.device.name,
            d.device.model,
            group ? group.name : '',
            Number((d.summary.distance / 1000).toFixed(0))
          ]
          data.push(temp)
        })
      }

      const footValues = []
      if (userData.byDriver) {
        footValues.push(
          'Total:' + reportData.drivers.length,
          '',
          (reportData.drivers.reduce((a, b) => a + b.summary.distance, 0) / 1000).toFixed(0)
        )
      } else {
        footValues.push(
          'Total:' + reportData.devices.length,
          '',
          '',
          (reportData.devices.reduce((a, b) => a + b.summary.distance, 0) / 1000).toFixed(0)
        )
      }

      const style = getStyle(getUserPartner(userData.user))

      const columnStyles = {}
      headers.forEach((h, i) => {
        columnStyles[i] = h === translations.report.distance ? { halign: 'right' } : {}
      })
      addTable(doc, headers, data, footValues, style, 35, columnStyles)
    }
    return doc
  }
}

function exportKmsReportToExcel (userData, reportData) {
  console.log('Export to Excel')

  const translations = getTranslations(userData)

  const settings = {
    sheetName: translations.report.titleKmsReport, // The name of the sheet
    fileName // The name of the spreadsheet
  }

  const info = userData.byDriver ? reportData.drivers : reportData.devices
  const columns = getExcelTableColumns(userData, info, translations)

  const data = []
  info.forEach(d => {
    data.push(...getExcelContent(userData, d, translations))
  })

  // add total
  if (data.length) {
    data.push({
      name: '',
      group: '',
      licenseplate: 'Total',
      distance: data.reduce((prev, curr) => curr.distance ? { distance: (prev.distance || 0) + curr.distance } : prev).distance
    })
  }

  return {
    headers: columns,
    data,
    settings
  }
}

function getExcelTableColumns (userData, info, translations) {
  const columns = []
  if (userData.groupByDay) {
    const partner = getUserPartner(userData.user)
    if (partner.reports.kmsReportDaysInColumns) {
      if (userData.byDriver) {
        columns.push(
          { label: translations.report.vehicle, value: 'name' },
          { label: translations.report.group, value: 'group' })
      } else {
        columns.push(
          { label: translations.report.vehicle, value: 'name' },
          { label: translations.settings.vehicle_licenseplate, value: 'licenseplate' },
          { label: translations.report.group, value: 'group' },
          { label: translations.report.startOdometer, value: 'startOdometer' })
      }

      const days = info[0].days
      days.forEach((day, index) => {
        columns.push({ label: new Date(day.date).toLocaleDateString(), value: 'day' + index })
      })

      if (userData.byDriver) {
        columns.push({ label: translations.report.total, value: 'total' })
      } else {
        columns.push({ label: translations.report.total, value: 'total' },
          { label: translations.report.endOdometer, value: 'endOdometer' })
      }
    } else {
      if (userData.byDriver) {
        columns.push(
          { label: translations.report.vehicle, value: 'name' },
          { label: translations.report.group, value: 'group' },
          { label: translations.report.date, value: 'date' },
          { label: translations.report.weekDay, value: 'weekday' },
          { label: translations.report.distance, value: 'distance' })
      } else {
        columns.push(
          { label: translations.report.vehicle, value: 'name' },
          { label: translations.settings.vehicle_licenseplate, value: 'licenseplate' },
          { label: translations.report.group, value: 'group' },
          { label: translations.report.date, value: 'date' },
          { label: translations.report.weekDay, value: 'weekday' },
          { label: translations.report.distance, value: 'distance' })
      }
    }
  } else if (userData.byDriver) {
    columns.push(
      { label: translations.report.driver, value: 'name' },
      { label: translations.report.group, value: 'group' },
      { label: translations.report.distance, value: 'distance' })
  } else {
    columns.push(
      { label: translations.report.vehicle, value: 'name' },
      { label: translations.settings.vehicle_licenseplate, value: 'licenseplate' },
      { label: translations.report.group, value: 'group' },
      { label: translations.report.distance, value: 'distance' })
  }
  return columns
}

function getExcelContent (userData, d, translations) {
  const weekDays = [
    translations.report.sunday,
    translations.report.monday,
    translations.report.tuesday,
    translations.report.wednesday,
    translations.report.thursday,
    translations.report.friday,
    translations.report.saturday
  ]

  const data = []
  const group = userData.byDriver
    ? userData.groups.find(g => g.drivers && g.drivers.includes(d.driver.id))
    : userData.groups.find(g => d.device.groupId === g.id)

  if (userData.groupByDay) {
    const partner = getUserPartner(userData.user)
    if (d.days) {
      if (partner.reports.kmsReportDaysInColumns) {
        const vehicle = {
          name: userData.byDriver ? d.driver.name : d.device.name,
          group: group ? group.name : '',
          licenseplate: userData.byDriver ? '' : d.device.attributes.license_plate,
          startOdometer: userData.byDriver ? '' : Number((d.startOdometer / 1000).toFixed(1)),
          endOdometer: userData.byDriver ? '' : Number((d.endOdometer / 1000).toFixed(1))
        }

        d.days.forEach((day, index) => {
          vehicle['day' + index] = Number((day.kms / 1000).toFixed(0))
        })

        vehicle.total = Number(d.days.reduce((a, b) => a + (b.kms / 1000), 0).toFixed(0))

        data.push(vehicle)
      } else {
        data.push({})
        data.push(...(d.days.map(a => {
          return {
            name: userData.byDriver ? d.driver.name : d.device.name,
            group: group ? group.name : '',
            licenseplate: userData.byDriver ? '' : d.device.attributes.license_plate,
            date: new Date(a.date).toLocaleDateString(),
            weekday: weekDays[new Date(a.date).getDay()],
            distance: Number((a.kms / 1000).toFixed(0))
          }
        })))
      }
    }
  } else {
    data.push({
      name: userData.byDriver ? d.driver.name : d.device.name,
      group: group ? group.name : '',
      licenseplate: userData.byDriver ? '' : d.device.attributes.license_plate,
      distance: Number((d.summary.distance / 1000).toFixed(0))
    })
  }
  return data
}

exports.createKmsReport = createKmsReport
exports.exportKmsReportToPDF = exportKmsReportToPDF
exports.exportKmsReportToExcel = exportKmsReportToExcel
exports.create = createKmsReport
exports.exportToPDF = exportKmsReportToPDF
exports.exportToExcel = exportKmsReportToExcel
